import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import AccountView from 'src/views/account/AccountView';
import MusicView from 'src/views/music/MusicView';
import VoiceoverView from 'src/views/voiceover/VoiceoverView';
import DashboardView from 'src/views/reports/DashboardView';
import LoginView from 'src/views/auth/LoginView';
import NotFoundView from 'src/views/errors/NotFoundView';
import Landing from 'src/views/landing/Landing';
import SubscribeView from 'src/views/subscribe/SubscribeView';

const routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'account/*', element: <AccountView /> },
      { path: 'dashboard', element: <DashboardView /> },
      { path: 'music', element: <MusicView /> },
      { path: 'voiceover', element: <Navigate to="/app/voice" /> },
      { path: 'voice', element: <VoiceoverView /> },
      { path: '*', element: <Navigate to="/404" /> },
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'login/*', element: <LoginView /> },
      { path: '/subscribe', element: <SubscribeView /> },
      { path: '404', element: <NotFoundView /> },
      { path: '/', element: <Landing /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

const signedOutRoutes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: '*', element: <Navigate to="/login" /> },
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'login/*', element: <LoginView /> },
      { path: '/newUser/login', element: <LoginView /> },
      { path: '/newUser/login/*', element: <LoginView /> },
      { path: '/newPro/login', element: <LoginView /> },
      { path: '/subscribe', element: <SubscribeView /> },
      { path: '404', element: <NotFoundView /> },
      { path: '/', element: <Landing /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export {
  routes,
  signedOutRoutes
} 
